




































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Watch } from 'vue-property-decorator';
import {
  BarChart2Icon,
  ChevronDownIcon,
  ChevronUpIcon,
  DownloadIcon,
  FilterIcon,
  GridIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import BusinessYearFilter from '@/components/filters/BusinessYearFilter.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import DateFilterComponent from '@/components/filters/DateFilter.vue';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import ProductFilterComponent from '@/components/filters/ProductFilter.vue';
import PolicyStatusFilterComponent from '@/components/filters/PolicyStatusFilter.vue';
import TagFilterComponent from '@/components/filters/TagFilter.vue';
import { FilterMixin } from '@/mixins/FilterMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { PolicyStatus, StatisticFilter, DateFilter, IUser, IProduct, ITag } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';
import { Util } from '@/utils/Util';
@Component({
  components: {
    DownloadIcon,
    BusinessYearFilter,
    TagSelect,
    HorizontalPolicyStatusSelect,
    'date-filter': DateFilterComponent,
    'user-filter': UserFilterComponent,
    'product-filter': ProductFilterComponent,
    'policy-status-filter': PolicyStatusFilterComponent,
    'tag-filter': TagFilterComponent,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    BarChart2Icon,
    UserIcon,
    XIcon,
    GridIcon,
  },
})
export default class StatisticFilterComponent extends mixins(FilterMixin, PermissionMixin) {
  filter: StatisticFilter = {
    businessYear: new Date().getFullYear(),
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    status: [PolicyStatus.POLICED],
    tags: [],
  };
  get isDefaultFilter() {
    return (
      this.filter.dateFilter === DateFilter.ALL &&
      this.filter.users?.length === 0 &&
      this.filter.products?.length === 0 &&
      this.filter.tags?.length === 0 &&
      this.filter.businessYear === new Date().getFullYear()
    );
  }
  updateDateFilter(filter: { dateFilter: DateFilter; from: number; to: number }) {
    this.filter.dateFilter = filter.dateFilter;
    if (filter.from) {
      this.filter.from = filter.from;
    }
    if (filter.to) {
      this.filter.to = filter.to;
    }
    this.updateFilter();
  }
  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }
    // TODO: workaround (get status from buttons first)
    const filter = (await this.$store.getters[
      'PreferencesModule/getStatisticFilter'
    ]) as StatisticFilter;
    this.filter.status = filter.status;
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setStatisticFilter}`,
      this.filter,
    );
    // workaround
    this.$root.$emit('change-policy-filter');
    this.close();
  }
  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }
  updateProductFilter(products: IProduct[]) {
    this.filter.products = [...products];
    this.updateFilter();
  }
  updateTagsFilter(tags: ITag[]) {
    this.filter.tags = [...tags];
    this.updateFilter();
  }
  updateBusinessYearFilter(year: number) {
    this.filter.businessYear = year;
    this.updateFilter();
  }
  resetFilter() {
    this.filter = {
      businessYear: new Date().getFullYear(),
      dateFilter: DateFilter.ALL,
      products: [],
      users: [],
      tags: [],
      status: [],
    };
    this.filter.users = [];
    this.filter.dateFilter = DateFilter.ALL;
    this.updateFilter();
    this.$root.$emit('reset-statistic-filter');
  }
  get statisticFilter() {
    return this.$store.getters['PreferencesModule/getStatisticFilter'];
  }
  @Watch('statisticFilter')
  async onPolicyFilterChanged(statisticFilter: StatisticFilter) {
    this.filter = statisticFilter;
  }
  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getStatisticFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    }
    this.$root.$on('update-policy-filter', async () => {
      await this.updateFilter();
    });
  }
  selectedFilterString() {
    let str = '';
    if (!this.isDefaultFilter || this.filter.dateFilter !== DateFilter.ALL) {
      str += this.dateFilterNames(this.filter.dateFilter!) + ', ';
    }
    if (this.filter.products && this.filter.products.length > 0) {
      str += this.filter.products[0].name + ', ';
    }
    if (this.filter.users && this.filter.users.length > 0) {
      str += this.filter.users[0].firstname + ', ';
    }
    if (this.filter.tags && this.filter.tags.length > 0) {
      str += '#' + this.filter.tags[0].name + ', ';
    }
    // if (!this.isDefaultFilter) {
    //   this.filter.status?.forEach((status: PolicyStatus) => {
    //     str += this.statusFilterNames(status) + ', ';
    //   });
    // }
    return str.substr(0, str.length - 2);
  }
  get isMobile() {
    return Util.isMobile();
  }
}
